const { CarouselElement } = window.BAO.Carousel
const { useCurrentSlideIndicator } = window.BAO.Carousel.plugins

export class ProductMedia extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide', 'status']
  }

  beforeInitialiseCarousel () {
    this.attachCarouselClasses()
  }

  attachCarouselClasses () {
    this.els.slider.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(slide => {
      slide.classList.add('keen-slider__slide')
    })
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      breakpoints: {
        '(min-width: 901px)': {
          disabled: true,
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    const { element: statusElement } = this.els.status

    return [
      useCurrentSlideIndicator(statusElement, statusElement.dataset.template),
    ]
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
